module.exports = __webpack_public_path__ + "static/media/Calendar.77b53053.svg";